import { openApp } from '@bilibili/h5-utils'
import { biliBridge, isSupport, inBiliApp } from '@bilibili/js-bridge'
export const inApp = inBiliApp
// const isProd = process.env.NODE_ENV === 'production'
const isIos = /\(i[^]+( U)? CPU.+Mac OS X/i.test(navigator.userAgent)
const isDev =
  process.env.NODE_ENV === 'development' ||
  process.env.VUE_APP_DEPLOY_ENV === 'development'
    ? true
    : false

export function openInApp() {
  let schema = `bilibili://browser?url=${encodeURIComponent(location.href)}`
  schema = isIos ? encodeURIComponent(schema) : schema
  openApp({
    schema,
    universalLink: location.href,
    delayDownload: true,
  })
}

export function goApp(): boolean {
  if (isDev) {
    return false
  }
  if (!inBiliApp) {
    const url = window.location.href
    let schema = `bilibili://browser?url=${encodeURIComponent(url)}`
    schema = isIos ? encodeURIComponent(schema) : schema
    openApp({
      schema,
      universalLink: url,
      delayDownload: true,
    })
    return true
  } else {
    return false
  }
}

export const webp = (function () {
  try {
    return (
      document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') === 0
    )
  } catch (err) {
    return false
  }
})()

// 保存图片至手机相册
export function savePictureToMobAlbum(filePath: string) {
  return new Promise((resolve) => {
    callNative({
      method: 'ability.saveImageToPhotosAlbum',
      data: {
        filePath,
        // base64Data,
      },
      callback: (info) => {
        resolve(info)
      },
    })
  })
}

export function callNative(options: any, errCb?: any): void {
  if (options.method) {
    isSupport(options.method).then((support: boolean) => {
      if (support) {
        biliBridge.callNative(options)
      } else {
        errCb && errCb()
      }
    })
  }
}

export function h5Login() {
  const prefix = 'https://account.bilibili.com/login?gourl='
  location.href = prefix + encodeURIComponent(location.href)
}

// 去登录 native 或者 h5
export function login(callback?: any) {
  if (inApp) {
    callNative(
      {
        method: 'auth.login',
        data: {
          type: 'default',
        },
        onLogin(data: any) {
          if (Number(data.state) === 1) {
            callback && callback()
          }
        },
      },
      h5Login
    )
  } else {
    h5Login()
  }
}

export function linkJump(link: string, callApp = false, replace = true) {
  if (!link) return
  if (
    process.env.NODE_ENV === 'uat' &&
    link.indexOf('/blackboard/') > -1 &&
    replace
  ) {
    link = link.replace(
      'www.bilibili.com/blackboard',
      'activity.bilibili.com/preview'
    )
  }
  let schema =
    link.indexOf('bilibili://') === 0
      ? link
      : `bilibili://browser?url=${encodeURIComponent(link)}`
  schema = isIos ? encodeURIComponent(schema) : schema
  if (inApp) {
    callNative(
      {
        method: 'ability.openScheme',
        data: {
          url: link,
        },
      },
      () => {
        if (callApp) {
          openApp({
            schema,
            universalLink: link,
            delayDownload: true,
          })
        } else {
          window.open(link)
        }
      }
    )
  } else {
    if (callApp) {
      openApp({
        schema,
        universalLink: link,
        delayDownload: true,
      })
    } else {
      window.open(link)
    }
  }
}

export function handleNoProtocol(url: string) {
  // 'https://site.com' -> '//site.com'
  return url && url.replace(/^https?:/i, '')
}

export function trimHttp(url: any) {
  return url ? url.replace(/^http(s)?:/, '') : ''
}

export function webpImg(url: any, w: any, h: any, c = false) {
  if (!url) {
    return url
  }
  const suffix = url.match(/(.*\.(jpg|jpeg|gif|png))(\?.*)?/)
  // 路径是否包含/bfs/
  const isBfs = url.indexOf('/bfs/') !== -1
  // 是否是GIF图片
  if (!suffix || suffix[2] === 'gif' || !isBfs) {
    return trimHttp(url)
  }
  // 裁剪规则
  w = Math.ceil(w)
  h = Math.ceil(h)
  let cut = w && h ? '@' + w + 'w_' + h + 'h' : '@'
  if (c) cut += '_1c'
  // 图片后参数 比如视频动态图
  const args = suffix[3] ? suffix[3] : ''
  if (webp) {
    return trimHttp(suffix[1] + cut + '.webp' + args)
  } else {
    return trimHttp(suffix[1] + cut + '.' + suffix[2] + args)
  }
}

export function loadImage(src: string) {
  return new Promise((resolve) => {
    const image = new Image()
    // 设置成可跨域
    image.crossOrigin = 'Anonymous'
    image.onload = () => {
      resolve(image)
    }
    image.onerror = () => {
      resolve(false)
    }
    image.src = src
  })
}

export function preloadImgs(imgList: string[], delay = 100, retryTimes = 3) {
  imgList = imgList || []
  delay = delay || 100
  return Promise.all(
    imgList.map((item) => {
      return new Promise((res, rej) => {
        if (!item) {
          res(true)
        } else {
          const img = new Image()
          let retry = 0
          img.onload = (e) => {
            res(e)
          }
          img.onerror = (err: any) => {
            retry++
            if (retry < retryTimes) {
              setTimeout(() => {
                img.src = item
              }, delay)
            } else {
              rej(err)
            }
          }
          img.src = item
        }
      })
    })
  )
}

export function isSupportWebp() {
  try {
    return (
      document
        .createElement('canvas')
        .toDataURL('image/webp', 0.5)
        .indexOf('data:image/webp') === 0
    )
  } catch (err) {
    return false
  }
}
